import { useEffect, useState } from "react"

// Refresh on every opening and ignore checks from a closed or replaced document.
export default function useResponseWarning(
  checkResponses: (() => Promise<boolean>) | undefined,
  open: boolean
) {
  const [result, setResult] = useState<{
    check: typeof checkResponses
    hasResponses: boolean
  } | null>(null)

  useEffect(() => {
    let active = true
    setResult(null)
    if (open) {
      void (checkResponses?.() ?? Promise.resolve(true))
        .catch(() => true)
        .then((hasResponses) => {
          if (active) setResult({ check: checkResponses, hasResponses })
        })
    }
    return () => {
      active = false
    }
  }, [checkResponses, open])

  return {
    checking: open && (!result || result.check !== checkResponses),
    hasResponses: result?.hasResponses ?? true
  }
}
